var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[(_vm.fieldBox)?_c('app-view-gallery-field-box_art',{attrs:{"field":_vm.fieldBox,"item":_vm.item}}):_vm._e(),_vm._l((_vm.metricFields),function(field){return _c(_vm.fieldComponent(field),{key:field.id,tag:"component",attrs:{"item":_vm.item,"field":field,"filter":_vm.filter}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }